import { css, CSSObject, Interpolation } from 'styled-components';

type ScreenSizes = 'sm' | 'md' | 'lg' | 'xl' | 'xxl';
type OrientationTypes = 'portrait' | 'landscape';

type Sizes = {
	[key in ScreenSizes]: number;
};

// TODO: Seems like styled-components removed the type for this, we need to look into how to fix this.
type FlattenInterpolation = Interpolation<object>;

type Orientation = {
	[key in OrientationTypes]: string;
};

export const sizes: Sizes = {
	sm: 320,
	md: 375,
	lg: 768,
	xl: 1028,
	xxl: 1750
};

const orientation: Orientation = {
	portrait: 'orientation: portrait',
	landscape: 'orientation: landscape'
};

type GetOrientation = {
	[key in OrientationTypes]: (
		style: TemplateStringsArray | CSSObject,
		...interpolations: Interpolation<object>[]
	) => FlattenInterpolation;
};

export const getorientation: GetOrientation = (
	Object.keys(orientation) as Array<OrientationTypes>
).reduce<GetOrientation>((accumulator, label: OrientationTypes) => {
	accumulator[label] = (style: TemplateStringsArray | CSSObject, ...interpolations: Interpolation<object>[]) =>
		css`
			@media (${orientation[label]}) {
				${css(style, ...interpolations)};
			}
		`;
	return accumulator;
}, {} as GetOrientation);

type Breakpoint = {
	[key in ScreenSizes]: (
		style: TemplateStringsArray | CSSObject,
		...interpolations: Interpolation<object>[]
	) => FlattenInterpolation;
};

const breakpoint: Breakpoint = (Object.keys(sizes) as Array<ScreenSizes>).reduce<Breakpoint>(
	(accumulator: Breakpoint, label: ScreenSizes) => {
		accumulator[label] = (style: TemplateStringsArray | CSSObject, ...interpolations: Interpolation<object>[]) =>
			css`
				@media (min-width: ${sizes[label]}px) {
					${css(style, ...interpolations)};
				}
			`;
		return accumulator;
	},
	{} as Breakpoint
);

export default breakpoint;

export const verticalBreakpoint: Breakpoint = (Object.keys(sizes) as Array<ScreenSizes>).reduce<Breakpoint>(
	(accumulator, label: ScreenSizes) => {
		accumulator[label] = (style: TemplateStringsArray | CSSObject, ...interpolations: Interpolation<object>[]) =>
			css`
				@media (min-height: ${sizes[label]}px) {
					${css(style, ...interpolations)};
				}
			`;
		return accumulator;
	},
	{} as Breakpoint
);

// Directly mapped to `\packages\mobile-core-assets\scss\src\utils\_z-index.scss`
// If this is updated, update the $elements scss variable as well.
const zIndexTypes = <const>[
	'base',
	'filters',
	'product-nav',
	'casino-nav',
	'subnavigation-games-header',
	'footer',
	'header',
	'header-icon',
	'product-filters',
	'footer-terms',
	'cookie-footer',
	'small-product-nav',
	'app-banner',
	'small-header',
	'subnavigation-games-header-mobile',
	'ingame',
	'inhouse-jackpot-winning-animations',
	'category-page',
	'sportsbook-popover-overlay',
	'sportsbook-popover-content',
	'game-info',
	'casino-filters-expanded',
	'blocked-view',
	'inbox-notification-slider',
	'sidebar',
	'overlay',
	'search-expanded',
	'bundles',
	'onboarding',
	'action-sheet-content',
	'exclusive-game-modal',
	'inhouse-jackpot-modal',
	'modal-view',
	'modal',
	'support-button',
	'support-nav',
	'spinner',
	'effect',
	'notification',
	'notification-wrap',
	'regulations-header-dga',
	'blocking-modal-view',
	'regulations-header',
	'cookie-consent',
	'cookie-banner-bg',
	'cookie-banner'
];

type ZIndexType = (typeof zIndexTypes)[number];

const getZindexByType = (type: ZIndexType): number => {
	return zIndexTypes.indexOf(type) + 1;
};

export { getZindexByType };
